import React from "react";
import PropTypes from "prop-types";

import useWidgetLogin from "../utils/useWidgetLogin";

const LoginPrompt = ({
  confirmId,
  ticketReservationToken,
  userContext,
  onAuthSuccess,
  rootUrl
}) => {
  const { isLoggedIn, handleLoginClick } = useWidgetLogin({
    confirmId,
    ticketReservationToken,
    userContext,
    onAuthSuccess,
    rootUrl
  });

  if (isLoggedIn) {
    return (
      <div className="d-flex align-items-center">
        {userContext.avatar_thumb_url && (
          <img
            src={userContext.avatar_thumb_url}
            alt=""
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              marginRight: 8
            }}
          />
        )}
        <span style={{ fontSize: 14, color: "var(--widget-font-color, #333)" }}>
          {userContext.first_name || userContext.email}
        </span>
      </div>
    );
  }

  return (
    <a
      href="#"
      onClick={handleLoginClick}
      style={{
        fontSize: 14,
        color: "var(--widget-link-color, #666)",
        textDecoration: "none"
      }}
    >
      Sign In
    </a>
  );
};

LoginPrompt.propTypes = {
  confirmId: PropTypes.number.isRequired,
  ticketReservationToken: PropTypes.string,
  userContext: PropTypes.object,
  onAuthSuccess: PropTypes.func.isRequired,
  rootUrl: PropTypes.string.isRequired
};

export default LoginPrompt;
